function initSearchControlBlocks(): void {
    const elements: NodeListOf<Element> = document.querySelectorAll('.search-control-block');

    if (elements.length === 0) return;

    elements.forEach((el: Element) => {
        const resetButtonElem = (el as HTMLElement).querySelector('button[type="reset"]') as HTMLButtonElement | null;
        const clearButtonElem = (el as HTMLElement).querySelector('button#clear-search-filters, button[data-clear-filters]') as HTMLButtonElement | null;
        const buttonElem = resetButtonElem ?? clearButtonElem;

        if (buttonElem != null) {
            buttonElem.addEventListener('click', (ev: Event) => {
                // If this is a fallback clear button (not a real reset button), prevent native behavior
                if (buttonElem !== resetButtonElem) {
                    ev.preventDefault();
                }

                const optionsWithSelectedAttribute: NodeListOf<HTMLOptionElement> = (el as HTMLElement).querySelectorAll('option[selected]');
                // The built in reset button doesn't reset options with the "selected" attribute. That's why we need to remove them ourselves.
                optionsWithSelectedAttribute.forEach((option: HTMLOptionElement) => {
                    option.removeAttribute('selected');
                });

                // If using the fallback clear button, also reset selects and checkboxes within the closest form (preserve original project-search behavior)
                if (buttonElem === clearButtonElem) {
                    const form = buttonElem.closest('form') as HTMLFormElement | null;
                    form?.querySelectorAll<HTMLSelectElement>('select').forEach((select) => {
                        select.selectedIndex = 0;
                    });
                    form?.querySelectorAll<HTMLInputElement>('input[type="checkbox"]').forEach((cb) => {
                        cb.checked = false;
                    });
                }

                const statusElem = (el as HTMLElement).querySelector('[data-reset-status]') as HTMLElement | null;
                const message = buttonElem.dataset.resetMessage || '';
                if (statusElem != null && message) {
                    // Clear first so the same message is re-announced on repeated resets.
                    statusElem.textContent = '';
                    window.setTimeout(() => { statusElem.textContent = message; }, 50);
                }

                const searchInput = (el as HTMLElement).querySelector('input[type="search"]') as HTMLInputElement | null;
                searchInput?.focus();
            });
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchControlBlocks);
} else {
    initSearchControlBlocks();
}
